<template>
  <div class="digital_wrap">
    <div class="top_area">
      <div class="dropdown_wrap">
        <ul class="main">
          <li>
            <a class="active">Blossom Logos</a>
            <ul class="sub" :class="{ active: activeCategoryIndex === index }">
              <li class="active">
                <a
                  @click="getCategorizedCampaign('')"
                  :class="currentCategorySeq === '' ? 'active' : ''"
                >
                  전체{{ getCurrentCategoryCount('') }}
                </a>
              </li>
              <li v-for="category in categories" :key="category.categorySeq">
                <a
                  @click="getCategorizedCampaign(category.categorySeq)"
                  :class="currentCategorySeq === category.categorySeq ? 'active' : ''"
                >
                  {{ category.name }}{{ getCurrentCategoryCount(category.categorySeq) }}
                </a>
              </li>
            </ul>
          </li>
        </ul>

      </div>
      <div class="slide_banner" ref="banner">
        <div class="banner_item" v-for="(image, index) in bannerImages">
          <img
            :src="image.src" :art="image.alt"
          />
        </div>
      </div>
    </div>

    <!-- <div class="best_campaign_wrap">
      <div class="best_campaign">
        <ul>
          <li>
            <a href="">
              <div class="img white">
                <img
                  src="../../assets/images/common/campaign_img_01.png"
                  alt=""
                />
              </div>
              <div class="txt">
                <div class="tit">
                  <span>[아동후원]</span>
                  아동 후원 디지털 축하 화환
                </div>
                <div class="date">상시 후원</div>
                <p class="team">(후원 단체명)</p>
              </div>
              <div class="review">
                <div class="score_wrap">
                  <div class="score" data-score="4"></div>
                </div>
                <div class="count">(3,123)</div>
              </div>
            </a>
          </li>
          <li>
            <a href="">
              <div class="img black">
                <img
                  src="../../assets/images/common/campaign_img_02.png"
                  alt=""
                />
              </div>
              <div class="txt">
                <div class="tit">
                  <span>[아동후원]</span>
                  아동 후원 디지털 축하 화환
                </div>
                <div class="date">~ 12/31</div>
                <p class="team">(후원 단체명)</p>
              </div>
              <div class="review">
                <div class="score_wrap">
                  <div class="score" data-score="5"></div>
                </div>
                <div class="count">(3,123)</div>
              </div>
            </a>
          </li>
          <li>
            <a href="">
              <div class="img white">
                <img
                  src="../../assets/images/common/campaign_img_01.png"
                  alt=""
                />
              </div>
              <div class="txt">
                <div class="tit">
                  <span>[아동후원]</span>
                  아동 후원 디지털 축하 화환
                </div>
                <div class="date">~ 11/31</div>
                <p class="team">(후원 단체명)</p>
              </div>
              <div class="review">
                <div class="score_wrap">
                  <div class="score" data-score="5"></div>
                </div>
                <div class="count">(3,123)</div>
              </div>
            </a>
          </li>
          <li>
            <a href="">
              <div class="img black">
                <img
                  src="../../assets/images/common/campaign_img_04.png"
                  alt=""
                />
              </div>
              <div class="txt">
                <div class="tit">
                  <span>[아동후원]</span>
                  아동 후원 디지털 축하 화환
                </div>
                <div class="date">상시 후원</div>
                <p class="team">(후원 단체명)</p>
              </div>
              <div class="review">
                <div class="score_wrap">
                  <div class="score" data-score="5"></div>
                </div>
                <div class="count">(3,123)</div>
              </div>
            </a>
          </li>
          <li>
            <a href="">
              <div class="img white">
                <img
                  src="../../assets/images/common/campaign_img_01.png"
                  alt=""
                />
              </div>
              <div class="txt">
                <div class="tit">
                  <span>[아동후원]</span>
                  아동 후원 디지털 축하 화환
                </div>
                <div class="date">상시 후원</div>
                <p class="team">(후원 단체명)</p>
              </div>
              <div class="review">
                <div class="score_wrap">
                  <div class="score" data-score="5"></div>
                </div>
                <div class="count">(3,123)</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div> -->






    <div class="campaign_wrap">
      <ul class="filter">
        <li>
          <a
            @click="getCategorizedCampaign('')"
            :class="currentCategorySeq === '' ? 'active' : ''"
          >
            전체{{ getCurrentCategoryCount('') }}
          </a>
        </li>
        <li v-for="category in parentCampaignCategories" :key="category.seq">
          <a
            @click="getCategorizedCampaign(category.seq)"
            :class="currentCategorySeq === category.seq ? 'active' : ''"
          >
            {{ category.name }}{{ getCurrentCategoryCount(category.seq) }}
          </a>
        </li>
        <!--
        <li v-for="category in categories" :key="category.categorySeq">
          <a
            @click="getCategorizedCampaign(category.categorySeq)"
            :class="currentCategorySeq === category.categorySeq ? 'active' : ''"
          >
            {{ category.name }}{{ getCurrentCategoryCount(category.categorySeq) }}
          </a>
        </li>
        -->
      </ul>
      <div class="campaign_head">
        <div class="total">총 <span>{{ campaignCount }}</span> 개</div>
        <div class="btn_wrap">
          <a @click="toggleBrdType" class="btn_list" :class="{ active: isListActive }"></a>
          <a @click="toggleBrdType" class="btn_gallery" :class="{ active: !isListActive }"></a>
        </div>
      </div>
      <div class="campaign_body">
        <ul class="gallery" :class="{ active: !isListActive }">
          <li v-for="(item, index) in campaigns">
            <a @click="toDetail(item.campaignSeq)">
              <div class="img">
                <img
                  :src="item.thumbnailPath ? $getImgUrl(item.thumbnailPath) : require('../../assets/images/common/campaign_img_01.png')"
                  alt=""
                />
              </div>
              <div class="txt">
                <div class="tit">
                  <span>[{{ item.category }}]</span>
                  {{ item.campaignName }}
                </div>
                <div class="date">{{ formatEndDate(item.endDate) }}</div>
                <p class="team">({{ item.partnerCompany }})</p>
              </div>
              <!-- <div class="review">
                <div class="score_wrap">
                  <div class="score" data-score="5"></div>
                </div>
                <div class="count">(3,123)</div>
              </div> -->
            </a>
          </li>

        </ul>
        <ul class="list" :class="{ active: isListActive }">
          <li v-for="(item, index) in campaigns">
            <a @click="toDetail(item.campaignSeq)">
              <div>
                <div class="img">
                  <img
                    :src="item.thumbnailPath ? $getImgUrl(item.thumbnailPath) : require('../../assets/images/common/campaign_img_01.png')"
                    alt=""
                  />
                </div>
                <div class="txt">
                  <div class="tit">
                    <span>[{{ item.category }}]</span>
                    {{ item.campaignName }}
                  </div>
                  <p class="team">{{ item.partnerCompany }}</p>
                  <!--<p class="cont" style="white-space: pre-line;">{{ item.description }}</p>-->
                  <!-- <div class="review">
                    <div class="score_wrap">
                      <div class="score" data-score="5"></div>
                    </div>
                    <div class="score_num">4.2</div>
                    <span>리뷰 1,145건</span>
                  </div> -->
                </div>
                <div class="date">{{ formatEndDate(item.endDate) }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <CustomerServicePagination
        :totalPages = "totalPages()"
        :currentPage = currentPage
        @changePage = "changePage"
      />
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { mapActions, mapState } from 'vuex';
import CustomerServicePagination from '../common/CustomerServicePagination.vue';

import "slick-carousel/slick/slick.css";
import "slick-carousel";

const campaignModule = 'campaignModule'
const categoryModule = 'categoryModule'
const campaignCategoryModule = 'campaignCategoryModule';

export default {
  components: {
    CustomerServicePagination
  },

  data () {
    return {
      autoplaySpeed: 4000,
      bannerImages: [
        {
          src: require('@/assets/images/common/banner_img_01.png'),
          alt: '디지털화환',
        },
        {
          src: require('@/assets/images/common/banner_img_01.png'),
          alt: '디지털화환',
        },
      ],
      activeCategoryIndex: 0,
      isListActive: true,
      currentPage: 1,
      currentCategorySeq: ''
    }
  },

  methods: {
    ...mapActions(campaignModule, [
      'requestCampaignList',
      'requestCampaignList1',
    ]),

    ...mapActions(categoryModule, [
      'requestCategoryList',
      'removeCategories'
    ]),

    ...mapActions(campaignCategoryModule, [
      'requestCampaignCategoryListWithChildren'
    ]),

    initBanner () {
      const { autoplaySpeed } = this;
      const $banner = $(this.$refs.banner);

      $banner.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed,
        prevArrow: $(".slide_prev"),
        nextArrow: $(".slide_next"),
        pauseOnFocus: false,
        pauseOnHover: false,
        rows: 0
      });
    },

    formatEndDate(endDate) {
      if (!endDate) {
        return '상시 후원';
      }

      const date = new Date(endDate);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `~ ${month}/${day}`;
    },

    toggleBrdType () {
      if (this.isListActive) {
        this.isListActive = false;
      } else {
        this.isListActive = true;
      }
    },

    async getCategorizedCampaign(categorySeq) {
      this.currentPage = 1
      this.currentCategorySeq = categorySeq

      const {currentPage, currentCategorySeq} = this
      await this.requestCampaignList1({currentPage, currentCategorySeq})
    },

    getCurrentCategoryCount(categorySeq) {
      if (this.currentCategorySeq === categorySeq) {
        return '(' + this.campaignCount + ')'
      }
      else return ''
    },

    totalPages () {
      return Math.ceil(this.campaignCount / 8);
    },

    async changePage (page) {
      this.currentPage = page
      const {currentPage, currentCategorySeq} = this
      await this.requestCampaignList1({currentPage, currentCategorySeq})
    },

    toDetail (campaignSeq) {
      this.$router.push({
        name: 'CampaignDtlPage',
        params: { campaignSeq: campaignSeq.toString() }
      })
    },

    removeLine (text) {
      return text.replace(/<br\s*\/?>/g, ' ')
    }
  },

  computed: {
    ...mapState(campaignModule, [
      'campaigns',
      'campaignCount'
    ]),

    ...mapState(categoryModule, [
      'categories'
    ]),

    ...mapState(campaignCategoryModule, [
      'campaignCategoryListWithChildren'
    ]),

    childCampaignCategories() {
      if (!this.campaignCategoryListWithChildren) {
        return [];
      }

      return this.campaignCategoryListWithChildren.flatMap(parentCategory => parentCategory.children);
    },

    parentCampaignCategories() {
      if (!this.campaignCategoryListWithChildren) {
        return [];
      }

      return this.campaignCategoryListWithChildren.map(({ children, ...parent }) => parent);
    }
  },

  async mounted () {
    this.initBanner();

    const {currentPage, currentCategorySeq, activeCategoryIndex} = this
    await this.requestCampaignList1({currentPage, currentCategorySeq})
    await this.requestCategoryList('캠페인')
    await this.requestCampaignCategoryListWithChildren();
  },
};
</script>
